const env = process.env.REACT_APP_ENV;

const firebaseConfigs = {
  development: {
    apiKey: "AIzaSyAom8qG0pWE3Ibt_XdeWMFdZm0GmURO664",
    authDomain: "dev-sorteolabolita.firebaseapp.com",
    databaseURL: "https://dev-sorteolabolita-default-rtdb.firebaseio.com",
    projectId: "dev-sorteolabolita",
    storageBucket: "dev-sorteolabolita.firebasestorage.app",
    messagingSenderId: "923479549623",
    appId: "1:923479549623:web:914b7bb267e8e0e6c34f32",
  },
  staging: {
    apiKey: "AIzaSyBYqt7kOGMvfKvSvhs-BxtsgYE0Egfn5ZI",
    authDomain: "staging-sorteolabolita.firebaseapp.com",
    databaseURL: "https://staging-sorteolabolita-default-rtdb.firebaseio.com",
    projectId: "staging-sorteolabolita",
    storageBucket: "staging-sorteolabolita.firebasestorage.app",
    messagingSenderId: "601406996203",
    appId: "1:601406996203:web:c994166dadf77ea5f208ae",
  },
  production: {
    apiKey: "AIzaSyC8ozAX_rcVCOF_KgpAP2UcaD4fOqRp6_k",
    authDomain: "sorteolabolita-75.firebaseapp.com",
    databaseURL: "https://sorteolabolita-75.firebaseio.com",
    projectId: "sorteolabolita-75",
    storageBucket: "sorteolabolita-75.firebasestorage.app",
    messagingSenderId: "221256415331",
    appId: "1:221256415331:web:f342b701f5dfa61d522056",
    measurementId: "G-3NT7TJT8EB",
  },
};

console.log(`Entorno -> ${env}`);
console.log(`Firebase ProjectId -> ${firebaseConfigs[env].projectId}`);

export default firebaseConfigs[env];
